import Instance from '../../../Axios';

// New Actions for the app

const GetPeqAlmocos = () => async (dispatch) => {
  await Instance()
    .get(`/backend/peqalmocos`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_PEQALMOCOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPeqAlmocos;
